import { render, staticRenderFns } from "./VIP.vue?vue&type=template&id=22c69732&"
import script from "./VIP.vue?vue&type=script&lang=js&"
export * from "./VIP.vue?vue&type=script&lang=js&"
import style0 from "./VIP.vue?vue&type=style&index=0&id=22c69732&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports